package domain.pieces

import engine.model.Matrix

object Gravinome {

    val I3 = GravinomePiece(
        -2,
        Matrix(
            3, 3,
            0, 0, 0,
            -2, -2, -2,
            0, 0, 0
        ),
        "I3",
        kicks = TRSKicks.I3
    )

    val C = GravinomePiece(
        -3,
        Matrix(
            2, 2,
            -2, 0,
            -2, -2
        ),
        "C",
        kicks = TRSKicks.C
    )

    val I = GravinomePiece(
        1,
        Matrix(
            4, 4,
            0, 0, 0, 0,
            1, 1, 1, 1,
            0, 0, 0, 0,
            0, 0, 0, 0
        ),
        "I",
        kicks = TRSKicks.I
    )

    val O = GravinomePiece(
        2,
        Matrix(
            2, 2,
            2, 2,
            2, 2
        ),
        "O"
    )

    val T = GravinomePiece(
        3,
        Matrix(
            3, 3,
            0, 3, 0,
            3, 3, 3,
            0, 0, 0
        ),
        "T",
        kicks = TRSKicks.STANDARD
    )

    val S = GravinomePiece(
        4,
        Matrix(
            3, 3,
            0, 4, 4,
            4, 4, 0,
            0, 0, 0
        ),
        "S",
        kicks = TRSKicks.STANDARD
    )

    val Z = GravinomePiece(
        5,
        Matrix(
            3, 3,
            5, 5, 0,
            0, 5, 5,
            0, 0, 0
        ),
        "Z",
        kicks = TRSKicks.STANDARD
    )

    val J = GravinomePiece(
        6,
        Matrix(
            3, 3,
            6, 0, 0,
            6, 6, 6,
            0, 0, 0
        ),
        "J",
        kicks = TRSKicks.STANDARD
    )

    val L = GravinomePiece(
        7,
        Matrix(
            3, 3,
            0, 0, 7,
            7, 7, 7,
            0, 0, 0
        ),
        "L",
        kicks = TRSKicks.STANDARD
    )

    val F = GravinomePiece(
        8,
        Matrix(
            4, 4,
            0, 8, 8, 0,
            8, 8, 0, 0,
            0, 8, 0, 0,
            0, 0, 0, 0
        ),
        "F",
        kicks = TRSKicks.F
    )

    val E = GravinomePiece(
        20,
        Matrix(
            4, 4,
            20, 20, 0, 0,
            0, 20, 20, 0,
            0, 20, 0, 0,
            0, 0, 0, 0
        ),
        "E",
        kicks = TRSKicks.E
    )

    val I5 = GravinomePiece(
        9,
        Matrix(
            5, 5,
            0, 0, 0, 0, 0,
            9, 9, 9, 9, 9,
            0, 0, 0, 0, 0,
            0, 0, 0, 0, 0,
            0, 0, 0, 0, 0
        ),
        "I5",
        kicks = TRSKicks.I5
    )

    val L5 = GravinomePiece(
        10,
        Matrix(
            4, 4,
            10, 10, 10, 10,
            10, 0, 0, 0,
            0, 0, 0, 0,
            0, 0, 0, 0
        ),
        "L5",
        kicks = TRSKicks.L5
    )

    val J5 = GravinomePiece(
        21,
        Matrix(
            4, 4,
            21, 21, 21, 21,
            0, 0, 0, 21,
            0, 0, 0, 0,
            0, 0, 0, 0
        ),
        "J5",
        kicks = TRSKicks.J5
    )

    val N = GravinomePiece(
        11,
        Matrix(
            4, 4,
            0, 11, 0, 0,
            11, 11, 0, 0,
            11, 0, 0, 0,
            11, 0, 0, 0
        ),
        "N",
        kicks = TRSKicks.N
    )

    val S5 = GravinomePiece(
        24,
        Matrix(
            4, 4,
            24, 0, 0, 0,
            24, 24, 0, 0,
            0, 24, 0, 0,
            0, 24, 0, 0
        ),
        "S5",
        kicks = TRSKicks.S5
    )


    val P = GravinomePiece(
        12,
        Matrix(
            4, 4,
            12, 12, 0, 0,
            12, 12, 0, 0,
            12, 0, 0, 0,
            0, 0, 0, 0
        ),
        "P",
        kicks = TRSKicks.P
    )

    val Q = GravinomePiece(
        22,
        Matrix(
            4, 4,
            22, 22, 0, 0,
            22, 22, 0, 0,
            0, 22, 0, 0,
            0, 0, 0, 0
        ),
        "Q",
        kicks = TRSKicks.Q
    )

    val Y = GravinomePiece(
        18,
        Matrix(
            4, 4,
            0, 18, 0, 0,
            18, 18, 0, 0,
            0, 18, 0, 0,
            0, 18, 0, 0
        ),
        "Y",
        kicks = TRSKicks.Y
    )

    val H = GravinomePiece(
        25,
        Matrix(
            4, 4,
            25, 0, 0, 0,
            25, 25, 0, 0,
            25, 0, 0, 0,
            25, 0, 0, 0
        ),
        "H",
        kicks = TRSKicks.H
    )

    val Z5 = GravinomePiece(
        19,
        Matrix(
            4, 4,
            19, 19, 0, 0,
            0, 19, 0, 0,
            0, 19, 19, 0,
            0, 0, 0, 0
        ),
        "Z5",
        kicks = TRSKicks.Z5
    )

    val R = GravinomePiece(
        23,
        Matrix(
            4, 4,
            0, 23, 23, 0,
            0, 23, 0, 0,
            23, 23, 0, 0,
            0, 0, 0, 0
        ),
        "R",
        kicks = TRSKicks.R
    )


    val T5 = GravinomePiece(
        13,
        Matrix(
            4, 4,
            13, 13, 13, 0,
            0, 13, 0, 0,
            0, 13, 0, 0,
            0, 0, 0, 0
        ),
        "T5",
        kicks = TRSKicks.T5
    )

    val U = GravinomePiece(
        14,
        Matrix(
            4, 4,
            14, 0, 14, 0,
            14, 14, 14, 0,
            0, 0, 0, 0,
            0, 0, 0, 0
        ),
        "U",
        kicks = TRSKicks.U
    )


    val V = GravinomePiece(
        15,
        Matrix(
            4, 4,
            15, 0, 0, 0,
            15, 0, 0, 0,
            15, 15, 15, 0,
            0, 0, 0, 0
        ),
        "V",
        kicks = TRSKicks.V
    )

    val W = GravinomePiece(
        16,
        Matrix(
            4, 4,
            16, 0, 0, 0,
            16, 16, 0, 0,
            0, 16, 16, 0,
            0, 0, 0, 0
        ),
        "W",
        kicks = TRSKicks.W
    )

    val X = GravinomePiece(
        17,
        Matrix(
            4, 4,
            0, 17, 0, 0,
            17, 17, 17, 0,
            0, 17, 0, 0,
            0, 0, 0, 0
        ),
        "X"
    )

    val trominoes = listOf(I3, C)
    val tetrominoes = listOf(I, O, T, S, Z, J, L)
    val pentominoes = listOf(E, F, H, I5, J5, L5, N, P, Q, R, S5, T5, U, V, W, X, Y, Z5)

    val definedPieces = trominoes + tetrominoes + pentominoes
}